<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('gusti')}}</h5>
        </div>
        <div slot="body">
            <div class="alert alert-info" v-if="this.isMaxTastesReached()">
                {{$t('max_picks_reached_1')}} {{this.max_tastes}} {{$t('max_picks_reached_2')}}
                {{this.max_picks_default}} {{$t('max_picks_reached_3')}}
                <br/>
                {{$t('max_picks_reached_4')}}
            </div>
            <div class="w-100" v-for="group in this.groups">
                <div class="mt-3 mb-2">
                    <b>
                        <span class="text-uppercase">{{group.alias}}</span>:
                    </b>
                    <br>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-2"
                     v-for="free_pick in group.processed_free_picks">
                    <div class="nome-scelte">
                        <b>{{free_pick.alias}}</b>
                        <span>
                            {{free_pick.variazione_prezzo.toFixedGood(2)}} {{locale_currency}}</span>
                    </div>
                    <div class="quantita-scelte">
                        <button class="btn btn-circle" @click="removeFreePick(free_pick)">
                            <i class="fa fa-minus"></i>
                        </button>
                        <span>{{current_picks.filter((pick) => pick.id === free_pick.id).length}}</span>
                        <button class="btn btn-circle" @click="addFreePick(free_pick)"
                                :disabled="isPlusDisabled(free_pick)">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="d-flex flex-fill justify-content-between">
            <button type="button" class="btn btn-default w-auto" @click="$emit('close')">
                {{$t('btn_annulla')}}
            </button>
            <button type="button" class="btn btn-primary w-auto" @click="$emit('close', current_picks)">
                {{$t('btn_salva')}}
            </button>
        </div>
    </modal>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';

    import Modal from '../../partials/Modal';

    export default {
        name: "ModalFreePicks",
        components: {Modal},
        props: ['product', 'currentFreePicks', 'measureId'],
        data() {
            return {
                current_picks: [],
                current_tastes: []
            }
        },
        computed: {
            groups: function () {
                let processed_groups = this.free_picks.gruppi;
                processed_groups.forEach((item) => {
                    item.processed_free_picks = [];
                });

                this.free_picks.ingredienti.forEach((ingredient) => {
                    if (ingredient.mask_locali_esclusi & this.locale.id) return;

                    const groupMeasure = this.free_picks.misure_gruppi.find((obj) => {
                        return (obj.id_misura_tipologia_prodotto === this.measureId && obj.id_gruppo_aggiunte === ingredient.id_gruppo_aggiunte);
                    });

                    if (groupMeasure) {
                        //Cerco se esiste un'override del prezzo
                        const override = ingredient.misure_prezzi_override.find((obj) => {
                            return (obj.id_misura_tipologia_prodotto === this.measureId);
                        });

                        let add = Object.assign({}, ingredient, {
                            variazione_prezzo: (override ? override.prezzo : groupMeasure.variazione_prezzo),
                            variazione_prezzo_originale: groupMeasure.variazione_prezzo,
                            f_override: !!override
                        });

                        processed_groups.forEach((item_processed_group) => {
                            if (item_processed_group.id === add.id_gruppo_aggiunte) {
                                add.nome_gruppo_aggiunte = item_processed_group.nome;
                                item_processed_group.processed_free_picks.push(add);
                            }
                        });
                    }
                });

                //sort...
                processed_groups.sort((item1, item2) => {
                    if (item1.alias < item2.alias) {
                        return -1;
                    }

                    if (item1.alias > item2.alias) {
                        return 1;
                    }

                    return 0;
                });

                processed_groups.forEach((item, index) => {
                    item.processed_free_picks.sort((item1, item2) => {
                        if (item1.alias < item2.alias) {
                            return -1;
                        }

                        if (item1.alias > item2.alias) {
                            return 1;
                        }

                        return 0;
                    });
                });

                return processed_groups.filter((group) => {
                    return group.processed_free_picks.length;
                });
            },
            free_picks: function () {
                return this.product.scelte_libere;
            },
            max_picks: function () {
                return this.product.max_scelte_libere - this.currentFreePicks.filter((free_pick) => free_pick).length;
            },
            max_picks_default: function () {
                return this.product.max_scelte_libere;
            },
            max_tastes: function () {
                return this.product.max_gusti_scelte_libere;
            },
            old_tastes: function () {
                return this.currentFreePicks.filter((obj, indexObj) => obj && this.currentFreePicks.findIndex((obj2) => obj.id === obj2.id) === indexObj).map((obj) => obj.id)
            },
            ...mapState('restaurant', {
                locale: state => state.locale
            }),
            ...mapGetters('restaurant', {
                locale_currency: 'localeCurrency'
            })
        },
        methods: {
            addFreePick: function (free_pick) {
                if (!this.current_tastes.includes(free_pick.id) && !this.old_tastes.includes(free_pick.id)) {
                    this.current_tastes.push(free_pick.id);
                }

                this.current_picks = this.current_picks.concat([free_pick]);
            },
            removeFreePick: function (free_pick) {
                const index = this.current_picks.findIndex((pick) => pick.id === free_pick.id);
                if (index >= 0) {
                    this.current_picks.splice(index, 1);

                    const indexAfter = this.current_picks.findIndex((pick) => pick.id === free_pick.id);
                    if (indexAfter < 0) {
                        this.current_tastes = this.current_tastes.filter((tasteId) => tasteId !== free_pick.id);
                    }
                }
            },
            isMaxTastesReached() {
                return this.max_tastes && this.current_tastes.concat(this.old_tastes).length >= this.max_tastes;
            },
            isPlusDisabled(free_pick) {
                return this.current_picks.length >= this.max_picks || (
                    this.isMaxTastesReached() && !this.current_tastes.concat(this.old_tastes).includes(free_pick.id)
                );
            }
        }
    }
</script>
